import { Controller } from "@hotwired/stimulus"

const OFFSCREEN_CLASSES = [ "translate-x-full", "-translate-x-full", "rtl:-translate-x-full" ]

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove(...OFFSCREEN_CLASSES, "opacity-0")
      this.element.classList.add("translate-x-0", "opacity-100")
    })

    this.timeout = setTimeout(() => this.dismiss(), 5000)
  }

  dismiss() {
    clearTimeout(this.timeout)
    const isRtl = document.documentElement.dir === "rtl"
    const exit = isRtl ? "-translate-x-full" : "translate-x-full"
    this.element.classList.remove("translate-x-0", "opacity-100")
    this.element.classList.add(exit, "opacity-0")
    setTimeout(() => this.element.remove(), 300)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
